export default {
  paises: [],
  provinces: [],
  paisSeleccionado: null,
  error: false,
  errorMessage: ''
}
